import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const customIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

export default function MapViewer({ sites }) {
  if (!sites || sites.length === 0) return <p>No site locations available</p>;

  const defaultPosition = [sites[0].latitude, sites[0].longitude];

  return (
    <MapContainer center={defaultPosition} zoom={6} style={{ height: "300px", width: "100%" }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {sites.map(site => (
        <Marker
          key={site._id}
          position={[site.latitude, site.longitude]}
          icon={customIcon}
        >
          <Popup>
            <strong>{site.name}</strong><br />
            {site.phoneNumber}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
